// extracted by mini-css-extract-plugin
export default {"collections":"CollectionSelect_collections__HbERw","menu":"CollectionSelect_menu__sLiyv","selected":"CollectionSelect_selected__QIELy"};